import { render, staticRenderFns } from "./OrderPlannerBacklog.vue?vue&type=template&id=45507af2&scoped=true&"
import script from "./OrderPlannerBacklog.vue?vue&type=script&lang=js&"
export * from "./OrderPlannerBacklog.vue?vue&type=script&lang=js&"
import style0 from "./OrderPlannerBacklog.vue?vue&type=style&index=0&id=45507af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45507af2",
  null
  
)

export default component.exports